import React, { createContext, useReducer } from "react"

import reducer from "./reducer.js"

export const ThemeContext = createContext()

const ThemeProvider = (props) => {
    const themeInitialState = {
        color: {
            primary: '#B7AB98',
            secondary: '#59EB39',
            cold: '#393632',
            teal: '#45fa1f',
            light: '#FCFCFC',
            dark: '#101010',
        },
    }

    const [state, dispatch] = useReducer(reducer, themeInitialState)

    return (
        <ThemeContext.Provider value={{ state: state, dispatch: dispatch }}>
            {props.children}
        </ThemeContext.Provider>
    )
}

export default ThemeProvider